import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Select, Tooltip } from '@radix-ui/themes';

import { TILE_TYPES } from '../constants';
import styles from './tile_type_filter.module.css';

export const TileTypeFilter = ({ tileType, setTileType }) => {
  const { t } = useTranslation('reports');
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    {
      value: TILE_TYPES.ALL,
      label: t('components.tileTypeFilter.allTiles'),
    },
    {
      value: TILE_TYPES.FEEDBACK,
      label: t('components.tileTypeFilter.feedbackTiles'),
    },
    {
      value: TILE_TYPES.SURVEY,
      label: t('components.tileTypeFilter.surveyTiles'),
    },
    {
      value: TILE_TYPES.QUIZ,
      label: t('components.tileTypeFilter.quizTiles'),
    },
    {
      value: TILE_TYPES.QA,
      label: t('components.tileTypeFilter.qaTiles'),
    },
  ];

  const handleChange = value => {
    setTileType(value);
  };

  const handleClear = e => {
    e.preventDefault();
    e.stopPropagation();
    setTileType(TILE_TYPES.ALL);
  };

  const showClearButton = tileType && tileType !== TILE_TYPES.ALL;

  return (
    <Flex direction="row" gap="3" align="center">
      <div className={styles.selectWrapper}>
        <Select.Root
          size="3"
          value={tileType || TILE_TYPES.ALL}
          onValueChange={handleChange}
          open={isOpen}
          onOpenChange={setIsOpen}
        >
          {showClearButton && (
            <button
              type="button"
              onClick={handleClear}
              onMouseDown={handleClear}
              className={styles.clearButton}
              style={{
                zIndex: isOpen ? 0 : 1,
              }}
            >
              <i className="fa-solid fa-xmark" />
            </button>
          )}
          <div className={styles.triggerContainer}>
            <Select.Trigger
              placeholder={t('components.tileTypeFilter.selectPlaceholder')}
              className={`${styles.trigger} ${styles.selectItem}`}
            />
          </div>
          <Select.Content position="popper" side="bottom">
            {options.map(option => (
              <Select.Item
                key={option.value}
                value={option.value}
                className={styles.selectItem}
              >
                {option.label}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </div>
      <Tooltip content={t('components.tileTypeFilter.tooltip')}>
        <i className="fa-regular fa-circle-info" />
      </Tooltip>
    </Flex>
  );
};
